<template>
    <div>
        <q-lead-counts v-if="lead_counts" :counts="lead_counts" @updatefilters="updateFilters" />
        <v-card class="mt-2">
            <v-card-title class="q_leads_1 align-start" style="font-size: 1rem" :id="entity + '_datatable'">
                <v-col cols="12" sm="8">
                    <div class="white--text d-flex align-center">
                        <p class="q-display-3 mb-0" id="datatable">
                            {{ title }}
                        </p>
                        <v-btn dark icon @click="refresh">
                            <v-icon>fas fa-redo-alt</v-icon>
                        </v-btn>
                    </div>
                    <p class="pt-2 mb-0">
                        <v-btn class="pa-2" text small color="q_leads_4" @click="toggleFilters">
                            <v-icon small left>fas fa-filter</v-icon> Filter Leads
                        </v-btn>
                    </p>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field :disabled="isDemoMode" dense dark v-model="search" append-icon="icon-q-search" label="Search" single-line hide-details @keyup="maybeSearch" @click:append="refreshData" />
                </v-col>
            </v-card-title>
            <v-card-text v-show="$refs.filters && $refs.filters.show">
                <v-row class="d-flex justify-start">
                    <q-filters dark ref="filters" :hide-button="true" v-model="filters" :available-filters="available_filters" :keys="filter_keys"></q-filters>
                </v-row>
            </v-card-text>
            <v-row class="mx-4 my-2">
                <v-col cols="12" sm="6">
                    <v-badge overlap color="transparent">
                        <template #badge>
                            <!-- <v-tooltip bottom>
                                TODO: Place here tooltip text
                                <template #activator="{ on, attrs }">
                                    <v-icon style="font-size: 14px !important;" v-bind="attrs" v-on="on" class="q_leads_4--text">far fa-question-circle</v-icon>
                                </template>
                                Here some helpful text about referrals
                            </v-tooltip> -->
                        </template>
                        <v-btn class="pa-2" text small color="q_leads_4" @click="create_referral_dialog = true">
                            <v-icon small left>fas fa-plus-square</v-icon> Create Referral
                        </v-btn>
                    </v-badge>
                </v-col>
                <v-col cols="12" sm="6" class="d-flex justify-end" v-if="total_items > 0 && !$vuetify.breakpoint.smAndDown">
                    <v-btn text small color="q_leads_4" @click="exportResults">
                        <v-icon small left>fas fa-file-export</v-icon> Export Results
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table v-on:current-items="updateCurrentItems" :mobile-breakpoint="2" :items-per-page.sync="rows" :search="search" v-model="selected" :headers="the_headers" :items="all_data" item-key="$id" class="elevation-0 pointer" :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }" :loading="loading" :options.sync="options" :server-items-length="total_items" v-on:click:row="viewLead">
                <template v-slot:item.Email="{ item }">
                    <a :href="'mailto:' + item.Email" class="nowrap">{{ item.Email }}</a>
                </template>
                <template v-slot:item.LeadCode="{ item }">
                    <span class="nowrap">
                        <span>{{ item.LeadCode }}</span>
                    </span>
                </template>
                <template v-slot:item.FirstName="{ item }">
                    <span class="nowrap"> {{ item.FirstName }} {{ item.LastName }} </span>
                </template>
                <template v-slot:item.AssignDate="{ item }">
                    <div>
                        {{ formatDate(item.AssignDate) }}
                        <v-tooltip right v-if="item.AgentNotLicensed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">fas fa-flag</v-icon>
                            </template>
                            <span>Non-Resident License Needed</span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-slot:body.append>
                    <tr>
                        <td colspan="10">
                            <v-progress-linear color="primary" indeterminate v-if="loading"></v-progress-linear>
                        </td>
                    </tr>
                    <!-- <tr>
                        <td colspan=2>
                            <v-btn dark color="q_leads_1" v-on:click="dialog = true">Send to Power Dialer</v-btn>
                        </td>
                        <td colspan=2>
                            <v-btn dark color="q_leads_1" v-on:click="showSyncDialog">Sync Disposition</v-btn>
                        </td>
                    </tr>-->
                </template>
            </v-data-table>
            <v-row wrap>
                <v-col cols="12" class="text-center">
                    <v-btn @click="hardRefresh" v-if="hasRole(['SuperAdmin', 'Staff'])">
                        Hard Refresh of Leads (Last 90 Days) <v-icon small right>fas fa-redo-alt</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <QLeadCardDialog
            v-model="view_lead_details"
            :lead="current_lead"
            :agent="agent"
            :statusOptions="status_items"
            :optBtnEnable="opt_btn_enable"
            @push-lead-to-opt="pushLeadToOpt"
            @input="current_lead = null"
            @save="updateLead"
        />
        <q-create-lead-referral :agent="agent" v-model="create_referral_dialog" :licensing="licensing" v-on:refresh="refresh"></q-create-lead-referral>
    </div>
</template>
<script>
import QDataTableMixin from "./QDataTableMixin";
import Lead from "@/store/Models/Lead";
import QuilityAPI from "@/store/API/QuilityAPI.js";
import { debounce } from "vue-debounce";
import QLeadCounts from "@/components/stats/QLeadCounts.vue";
import QDatePicker from "@/components/utils/QDatePicker.vue";
import { Device } from "@twilio/voice-sdk";
import rules from "@/components/utils/ValidationRules";
import StateOptions from "@/store/StateOptions";
import QDataTableHeader from "./base/QDataTableHeader.vue";
import QCreateLeadReferral from "@/components/utils/QCreateLeadReferral.vue";
import QLeadLookup from "@/components/utils/QLeadLookup.vue";
import QLeadCardDialog from "@/components/dialog/QLeadCardDialog.vue";
import Cookies from 'js-cookie'

export default {
    name: "QLeadDataTable",
    mixins: [QDataTableMixin],
    props: ["agent"],
    data: function() {
        // data internal to component (not available outside)
        return {
            entity: "lead",
            view_lead_details: false,
            //use this to "preset" a filter
            filters: {},
            firstPull: true, // this keeps the auto scrolling on data reloads from happening on the first load.
            leads: [],
            lead_counts: null,
            current_lead: null,
            options: { sortBy: ["AssignDate"], sortDesc: ["true"] },
            status_items: [],
            is_exporting: false,
            twilioVoiceToken: null,
            in_call: false,
            device: null,
            create_referral_dialog: false,
            rules: rules, //validation rules imported.
            states: StateOptions, //for the state drop down list
            warning: null,
            error: null,
            validReferral: true,
            licensing: null,
            DuplicateLeadAssignment : null,
            opt_btn_enable : true
        };
    },
    mounted: function() {
        this.loadStatuses();
        this.getTwilioToken();
        this.loadlicensing();
    },
    computed: {
        filter_keys: function() {
            return Lead.state().filter_keys;
        },
        all_data: function() {
            return this.leads
        },
        is_valid: function() {
            return true;
        },
        the_headers() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return [{
                        text: "Assign Date",
                        value: "AssignDate",
                        align: "start",
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "Name",
                        value: "FirstName",
                        align: "start",
                        sortable: true,
                        filterable: true,
                        class: "header-class",
                    },
                ];
            }

            if (this.$vuetify.breakpoint.md) {
                return [{
                        text: "Assign Date",
                        value: "AssignDate",
                        align: "start",
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "Name",
                        value: "FirstName",
                        align: "start",
                        sortable: true,
                        filterable: true,
                        class: "header-class",
                    },
                    {
                        text: "Type",
                        value: "LeadType",
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "Status",
                        value: "LeadStatus",
                        sortable: true,
                        filterable: true,
                    },
                ];
            }

            const r = [{
                    text: "Assign Date",
                    value: "AssignDate",
                    align: "start",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Name",
                    value: "FirstName",
                    align: "start",
                    sortable: true,
                    filterable: true,
                    class: "header-class",
                },
                {
                    text: "State",
                    value: "State",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Phone",
                    value: "Phone",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Email",
                    value: "Email",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Type",
                    value: "LeadType",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Status",
                    value: "LeadStatus",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Level",
                    value: "LeadLevelAlias",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Referral Source",
                    value: "SourceofReferral",
                    sortable: true,
                    filterable: true,
                },
            ];

            if (this.hasRole(["Staff", "Exec", "SuperAdmin"])) {
                r.push({
                    text: "Source",
                    value: "LeadSource",
                    align: "start",
                });
                r.push({
                    text: "SubSource",
                    value: "LeadSubSource",
                    align: "start",
                });
            }
            return r;
        },
        time_options: function() {
            var r = [];
            var ampm = "AM";
            for (var a = 0; a < 2; a++) {
                for (var i = 1; i < 12; i++) {
                    for (var m = 0; m < 2; m++) {
                        r.push((i == 0 ? "00" : i) + ":" + (m == 0 ? "00" : m * 30) + " " + ampm);
                    }
                }
                r.push("12:00 PM");
                r.push("12:30 PM");
                ampm = "PM";
            }
            return r;
        },
    },
    methods: {
        loadData: debounce(function(opt) {
            var g = this;
            if (this.lead_counts === null) {
                opt.NeedLeadCounts = true;
            } else {
                opt.NeedLeadCounts = false;
            }
            if (this.is_exporting) {
                opt.itemsPerPage = "csv";
            }
            QuilityAPI.getLeads(this.agent.AgentCode, this.filters, opt)
                .then(function(results) {
                    if (g.is_exporting) {
                        var fileURL = window.URL.createObjectURL(new Blob([results]));
                        var fileLink = document.createElement("a");
                        fileLink.href = fileURL;
                        fileLink.setAttribute("download", "leads.csv");
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    } else {
                        if (typeof results.data != "undefined") {
                            g.leads = results.data;
                            if (results.counts) {
                                g.lead_counts = results.counts;
                            }
                        } else {
                            g.showError("Whoops! " + results.message);
                        }
                    }
                    g.is_exporting = false;
                    Lead.commit((state) => {
                        state.loading = false;
                    });
                })
                .catch(function(err) {
                    console.log(err);
                    if (err.status == 431) {
                        g.showError(err + " You probably need to clear all your cookie and session variables and login again.");
                        return;
                    }
                    //g.showError(err.status)
                });
            this.firstPull = false;
        }, 200),
        updateLead(lead) {
            QuilityAPI.updateLead(this.agent.AgentCode, lead)
                .then((response) => {
                    if (!response.Successfull) {
                        this.showError(response.Message);
                    } else {
                        this.current_lead.LeadStatus = lead.LeadStatus;
                        this.current_lead.Comments = lead.Comments;
                        this.showSuccess(response.Message);
                        this.logActivity("UpdateLead", { LeadCode: this.current_lead.LeadCode });
                        this.view_lead_details = false;
                        this.current_lead = null;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.showError(err.msg);
                });
        },
        pushLeadToOpt: function(leadcode) {
            this.opt_btn_enable = false
            var g = this;
            QuilityAPI.pushLeadToOpt(this.agent.AgentCode, leadcode)
                .then(function(response) {
                    console.log(response);
                    if (!response.Successfull) {
						g.opt_btn_enable = true;
                        g.showError(response.message);
                    } else {
						const now = new Date();
						now.setTime(now.getTime() + 60 * 60 * 1000)
						document.cookie = `opt_btn_disabled_${leadcode}=1;expires=${now.toUTCString()};path=/`
						g.opt_btn_enable = false
                        g.showSuccess("This lead has been successfully pushed to Opt! It can take 30 minutes to an hour for it to show up in Opt.");
                    }
                })
                .catch(function(err) {
                    console.log(err);
                    g.showError(err.msg);
                    g.opt_btn_enable = true;
                });
        },
        viewLead: function(lead) {
            this.current_lead = lead;
            this.view_lead_details = true;

			const cookieKey = `opt_btn_disabled_${lead.LeadCode}`
            this.opt_btn_enable = !Cookies.get(cookieKey)
        },
        loadStatuses: function() {
            var g = this;
            QuilityAPI.getStatusOptions()
                .then(function(response) {
                    g.status_items = response;
                })
                .catch(function(err) {});
        },
        refresh: function() {
            this.leads = [];
            this.lead_counts = null;
            Lead.commit((state) => {
                state.total = null;
                state.availableFilters = null;
            });
            this.refreshData();
        },
        hardRefresh : function(){
            this.leads = [];
            this.lead_counts = null;
            Lead.commit((state) => {
                state.total = null;
                state.availableFilters = null;
            });
            var extra = {
                needAvailableFilters: true,
                hardRefreshLeads : true
            }
            var opt = {
                ...this.options,
                search: this.search,
                ...extra
            }
            this.loadData(opt);
        },
        exportResults: function() {
            var opt = {
                ...this.options,
                search: this.search,
            };
            var endpoint = "/api/private/leads/agent/" + this.agent.AgentCode;
            var params = {
                ...opt,
                ...this.filters,
                itemsPerPage: "csv",
            };
            this.dispatchJob({
                method: "GET",
                path: endpoint,
                params: params,
                JobName: "Leads Export",
            });

            //this.is_exporting = true
            //this.refreshData();
        },
        status_itemsHasIndexOf: function(s) {
            for (var i = 0; i < this.status_items.length; i++) {
                if (this.status_items[i].LeadStatus == s) {
                    return true;
                }
            }
            return false;
        },
        getStatus: function(s) {
            for (var i = 0; i < this.status_items.length; i++) {
                if (this.status_items[i].LeadStatus == s) {
                    return this.status_items[i];
                }
            }
            return null;
        },
        updateFilters(filters) {
            Object.keys(this.filters).forEach((key) => {
                this.filters[key] = filters[key] || "-All-";
            });

            this.goToTop();
        },
        goToTop: function() {
            this.$vuetify.goTo("#lead_datatable", {
                duration: 500,
                easing: "easeOutCubic",
                offset: 300,
            });
        },
        getTwilioToken: function() {
            fetch("/api/public/twilio/token")
                .then((response) => response.text())
                .then((token) => {
                    this.twilioVoiceToken = token;
                });
        },
        call: async function() {
            //initiate call to this.current_lead.Phone

            this.in_call = true;
            this.device = new Device(this.twilioVoiceToken);
            this.device.on("error", (twilioError, call) => {
                console.log("An error has occurred: ", twilioError);
            });

            let call = await this.device.connect({
                params: {
                    To: this.current_lead.Phone,
                },
            });
            call.on("disconnect", (connection) => {
                this.in_call = false;
            });
        },
        hangUp: function() {
            this.device.disconnectAll();
            this.in_call = false;
        },
        loadlicensing: function() {
            var g = this;

            QuilityAPI.getAgentLicensing(this.agent, this.role).then(function(resp) {
                if (resp.data) {
                    g.$set(g, "licensing", resp.data.licenses);
                } else {
                    g.showError(resp.reason);
                }
            });
        },
    },
    watch: {
        view_lead_details: function() {
            if (!this.view_lead_details || !this.current_lead) return;

            this.logActivity("ViewLead", { LeadCode: this.current_lead.LeadCode });
        },
    },
    components: {
        QLeadCounts,
        QDatePicker,
        QDataTableHeader,
        QCreateLeadReferral,
        QLeadLookup,
        QLeadCardDialog,
    },
};
</script>
<style scoped>
.nowrap {
    white-space: nowrap;
}

.table-cursor tbody tr:hover {
    cursor: pointer;
}

.dialog-actions-container {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	gap: 0.75rem 1rem;
}
</style>